import React from "react";
import ViewPrefferPartner from "../component/PrefferPartner/ViewPrefferPartner";

const PrefferPartner = () => {
  return (
    <>
      <ViewPrefferPartner />
    </>
  );
};

export default PrefferPartner;
